import { useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import LiaiseWordmark from "../brand/LiaiseWordmark";
import { api } from "../api/client";

const ADMIN_SWA_URL =
  (import.meta.env.VITE_ADMIN_SWA_URL as string | undefined) ??
  "https://expenses-admin.liaisegroup.com";

export default function AppShell({ children }: { children: React.ReactNode }) {
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const { data: me } = useQuery({ queryKey: ["me"], queryFn: api.me });

  const isApprover = me?.is_approver ?? false;
  const pending = Number(me?.pending_approvals ?? 0);

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-liaise-navy text-white">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <LiaiseWordmark className="h-7 w-auto" />
            <span className="text-white/40">|</span>
            <span className="font-medium">Expenses</span>
          </div>
          <div className="text-sm flex items-center gap-4">
            {isApprover && (
              <a
                href={`${ADMIN_SWA_URL}/approvals`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/90 hover:text-white border border-white/30 hover:border-white/50 rounded-full px-3 py-1 transition"
                title="Open the manager / admin app"
              >
                <span>Approvals</span>
                {pending > 0 && (
                  <span className="bg-liaise-yellow text-liaise-navy text-xs font-semibold px-1.5 py-0.5 rounded-full min-w-[18px] text-center">
                    {pending}
                  </span>
                )}
              </a>
            )}
            <span className="text-white/80">{account?.name ?? account?.username}</span>
            <a
              href="/Expenses-Policy.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/80 hover:text-white underline-offset-4 hover:underline"
              title="Read the Liaise Expenses Policy (PDF)"
            >
              Expenses policy
            </a>
            <Link
              to="/preferences"
              className="text-white/80 hover:text-white underline-offset-4 hover:underline"
              title="Email preferences"
            >
              Preferences
            </Link>
            <button
              onClick={() => instance.logoutRedirect()}
              className="text-white/80 hover:text-white underline-offset-4 hover:underline"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-6xl mx-auto w-full px-6 py-8">{children}</main>

      <footer className="border-t border-slate-200 py-4 text-center text-sm text-slate-500">
        Your goals are our goals.
      </footer>
    </div>
  );
}
